import React from 'react'

const FurtherTrainingBorderBox = () => {
    return (
        <div className="border-box">
            <h2>Need Training?</h2>

            <p>
                If you need further training or would like to walk through some live case scenarios,
                please schedule a time today!
            </p>

            <div style={{ marginTop: '25px' }}>
                <a
                    href="https://meetings.hubspot.com/james-leary"
                    target="_blank"
                    className="btn arrow-btn-full"
                >
                    SCHEDULE TRAINING<span></span>
                </a>
            </div>
        </div>
    )
}

export default FurtherTrainingBorderBox
